/**
 * useMonsters Hook
 *
 * Consumes MonsterStateContext. All callers see the same monster state (lists + selection).
 * Use this in phases, useBoard, MonsterList, MonsterDeduction, etc.
 *
 * Must be used within MonsterStateProvider (inside GamePage).
 */

import { useMonsterStateContext } from '../context/useMonsterStateContext';

export type { MonsterStateContextValue as UseMonstersReturn } from '../context/MonsterStateContext';

/**
 * useMonsters hook
 * @returns Monster state and management functions from MonsterStateContext
 */
export const useMonsters = () => useMonsterStateContext();

export default useMonsters;
